/**
 *
 * Asynchronously loads the component for CatalogPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
